import React from 'react';
import styled from 'styled-components';
import messages from './messages';

import { FormattedMessage } from 'react-intl';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const Description = () => (
    <div>
        <Title>
            <FormattedMessage {...messages.subHeading} />
        </Title>
        <hr style={{ marginBottom: '2em' }} />
    </div>
);

export default Description;
